import {Injectable} from '@angular/core';
import {Observable, Subject} from 'rxjs';
import {HttpClient} from '@angular/common/http';
import {PresetModel} from '../Models/preset-model';
import {environment} from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class PresetService {

  public presets: PresetModel[];

  public presetSubject = new Subject();

  constructor(private http: HttpClient) {
  }

  public loadPresets(): Observable<PresetModel[]> {

    if (this.presets) {
      return;
    }
    this.http.get<PresetModel[]>(environment.baseURl + '/api/decisionGrid/presets/GetPresets').subscribe((r: PresetModel[]) => this.presets = r);
  }

  public applyPresets(preset: PresetModel) {
    return this.http.post<PresetModel>(environment.baseURl + '/api/decisionGrid/presets/ApplyPresets', preset);
  }
}
